"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSettingsDataSaga = getSettingsDataSaga;
exports.setSettingsDataSaga = setSettingsDataSaga;
exports.setCookieSettingsDataSaga = setCookieSettingsDataSaga;
exports.settingsProviderSaga = settingsProviderSaga;
const effects_1 = require("redux-saga/effects");
const js_cookie_1 = __importDefault(require("js-cookie"));
const omit_1 = __importDefault(require("lodash/omit"));
const selectors_1 = require("./selectors");
const constants_1 = require("./constants");
const errors_1 = require("../../utils/errors");
const api_1 = require("../../api/profiles/api");
const slice_1 = require("./slice");
function* getSettingsDataSaga() {
    try {
        const { data } = yield (0, effects_1.call)(api_1.getCurrentClientSettings);
        const settingsData = (0, omit_1.default)(data, ['clientId', 'userId']);
        yield (0, effects_1.put)(slice_1.settingsProviderActions.getSettingsDataSuccess(settingsData));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching user', error);
        yield (0, effects_1.put)(slice_1.settingsProviderActions.getSettingsDataError(error));
    }
}
function* setSettingsDataSaga(action) {
    try {
        const { data } = yield (0, effects_1.call)(api_1.updateCurrentClientSettings, {
            clientSettingsUpdate: action.payload,
        });
        const settingsData = (0, omit_1.default)(data, ['userId', 'clientId']);
        yield (0, effects_1.put)(slice_1.settingsProviderActions.setSettingsDataSuccess(settingsData));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching user', error);
        yield (0, effects_1.put)(slice_1.settingsProviderActions.getSettingsDataError(error));
    }
}
function* setCookieSettingsDataSaga() {
    const settingsData = yield (0, effects_1.select)(selectors_1.selectSettingsData);
    yield js_cookie_1.default.set(constants_1.COOKIE_USER_SETTINGS_NAME, `${JSON.stringify(settingsData)}`, {
        expires: 365,
        path: '/',
    });
}
function* settingsProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_1.settingsProviderActions.getSettingsData, getSettingsDataSaga),
        (0, effects_1.takeLatest)(slice_1.settingsProviderActions.setSettingsData, setSettingsDataSaga),
        (0, effects_1.takeLatest)([
            slice_1.settingsProviderActions.getSettingsDataSuccess,
            slice_1.settingsProviderActions.setSettingsDataSuccess,
        ], setCookieSettingsDataSaga),
    ]);
}
//# sourceMappingURL=saga.js.map